import Cookies from 'js-cookie';

export function requestServiceInit() {
  const referralForm = $('input[value="GAreferralsSubmit"]').parent('form');
  // eslint-disable-next-line no-unused-vars
  let Validator;

  if (referralForm.length > 0) {
    (function () {
      const fields = referralForm.find('.jquery-required');
      const rules = {};
      const messages = {};

      fields.each(function (index) {
        if ($(fields[index]).hasClass('wpcf7-email')) {
          rules[this.name] = { required: true, email: true };
          messages[this.name] = {
            required: 'This field is required.',
            email: 'Please supply a valid email',
          };
        } else {
          rules[this.name] = 'required';
          messages[this.name] = 'This field is required.';
        }
      });

      Validator = referralForm.validate({
        rules,
        messages,
        focusCleanup: true,
        focusInvalid: true,
        errorClass: 'form__error',
        errorElement: 'span',
        errorPlacement(error, element) {
          if (element.attr('type') === 'checkbox') {
            error.insertAfter(element.parents('.wpcf7-checkbox'));
          } else {
            error.insertAfter(element);
          }
        },
      });
    })();

    referralForm.find('button[type="submit"]').on('click', (e) => {
      if (!referralForm.valid()) {
        e.preventDefault();
      }
    });
  }

  if ($('#tfa_dbFormId').val() === '184365') {
    // Form abandonment
    (function () {
      let eventAction;
      let referrerType;
      const attribute = 'title';
      const checkSubmit = function () {
        let i = window.dataLayer.length - 1;
        while (i > -1) {
          if (window.dataLayer[i].event === 'gtm.formSubmit') {
            return true;
          }
          i--;
        }
      };

      // Push event
      window.addEventListener('beforeunload', () => {
        if (referrerType && !checkSubmit()) {
          window.dataLayer.push({
            event: 'formAbandonment',
            eventCategory: 'Form Abandonment',
            lastInteraction: eventAction,
            referrerType,
          });
        }
      });

      // Set last interacted element on form
      document
        .querySelector('.wFormContainer form')
        .addEventListener('change', (e) => {
          eventAction = e.target.getAttribute(attribute);
        });

      // Set referrer type on change
      document.querySelector('#tfa_125').addEventListener('change', (e) => {
        referrerType = document.getElementById(e.target.value).textContent;
      });
    })();

    // Submit another client (Health professionals)
    (function () {
      // Listen to change on select
      const referrerType = document.querySelector('#tfa_125');

      if (!referrerType) {
        return;
      }

      // Referrer details
      const referrerFirstName = document.querySelector('#tfa_63');
      const referrerLastName = document.querySelector('#tfa_130');
      const referrerOrg = document.querySelector('#tfa_64');
      const referrerPosition = document.querySelector('#tfa_180');
      const referrerMobile = document.querySelector('#tfa_65');
      const referrerEmail = document.querySelector('#tfa_66');

      var handleChange = function () {
        // If Health Professional, add another button to submit and make another referral without having to fill in referrer details again
        if (referrerType.value === 'tfa_129') {
          // Add submit button
          const submitBtn = document.querySelector('#submit_button');

          if (!submitBtn) {
            return;
          }

          // Lets add another submit button...
          const btn = document.createElement('input');

          btn.value = 'Submit and add another client';
          btn.type = 'submit';
          btn.id = 'addClientBtn';
          btn.className = 'primaryAction';
          btn.style = 'width: auto !important;';
          btn.setAttribute('data-referrer-form', 'referrer-add-client');
          btn.onclick = function () {
            // Set cookie with referrer values and post to FA
            const referrerData = {
              firstName: referrerFirstName.value,
              lastName: referrerLastName.value,
              organisation: referrerOrg.value,
              position: referrerPosition.value,
              mobile: referrerMobile.value,
              email: referrerEmail.value,
            };

            Cookies.set('referrer-details', referrerData);
          };
          btn.disabled = true;

          // LIsten to submitBtn to see when it's been enabed
          listenTo(submitBtn, btn);

          submitBtn.style = 'width: auto !important;';
          submitBtn.parentElement.appendChild(btn);

          // Remove listener since we've added the button...
          referrerType.removeEventListener('change', handleChange, false);
        }
      };

      var listenTo = function (btn, newBtn) {
        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: false, subtree: false };

        // Callback function to execute when mutations are observed
        const callback = function (mutationsList) {
          for (const mutation of mutationsList) {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'disabled'
            ) {
              newBtn.disabled = btn.disabled;
            }
          }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(btn, config);
      };

      referrerType.addEventListener('change', handleChange, false);

      // Set defaults if cookie (or param) is set
      const referrerCookie = Cookies.get('referrer-details');

      if (referrerCookie) {
        const referrerData = $.parseJSON(referrerCookie);

        // Set referrer type to Health Professional and assign values from session
        referrerFirstName.value = referrerData.firstName;
        referrerLastName.value = referrerData.lastName;
        referrerOrg.value = referrerData.organisation;
        referrerPosition.value = referrerData.position;
        referrerMobile.value = referrerData.mobile;
        referrerEmail.value = referrerData.email;

        // Update referrer type and trigger change event
        referrerType.value = 'tfa_129';
        referrerType.dispatchEvent(new Event('change'));

        // Display success message
        $(
          '<p class="referralSuccess" style="border: none; background: #F1E0CA; padding: 1.4em; margin: 1.4em 0;">Thank you for your referral application. Please add your next client <a href="#tfa_71-D">below</a>.</p>',
        ).insertBefore('#tfa_125-D');

        // Scroll to top of form
        $('html, body').animate(
          {
            scrollTop: $('.referralSuccess').offset().top - 20,
          },
          500,
        );

        // Kill cookie
        Cookies.remove('referrer-details');
      }
    })();
  }
}
